import { _s } from '@/locale';

export const DEFAULT_SEARCH_KEYWORD = 'vad';
export const DEFAULT_SEARCH_LOCATION = 'hela_sverige';
export const DEFAULT_MY_LOCATION_KEYWORD = _s('currentLocation');
